import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { authApi, publicApi } from '@/utils/api';
//"선택"한 보고서가 가지고 있는 비즈니스 사례 리스트와,
//각 비즈니스 사례의 내용 해시

const business_cases = {
  namespaced: true,
  state: {
    business_case_list: [
      // {
      //     "index": 0,
      //     "business_case_id": 3,
      //     "report_code": "r11",
      //     "title": "",
      //     "badge_text": "Case",
      //     "description": "",
      //     "time_stamp": "2020-08-13 17:37:25",
      //     "used_codes": [
      //         "404-1"
      //     ],
      //     "files": [
      //         {
      //             "index": 0,
      //             "file_id": 1,
      //             "business_case_id": 3,
      //             "type": "file",
      //             "file_name": "Welcome to Show.show",
      //             "file_path": "C:\\Inetpub\\gri_backend\\app\\../uploads\\business_cases\\3",
      //             "time_stamp": "2020-08-13 17:38:44"
      //         }
      //     ],
      //     "images": [
      //         {
      //             "index": 0,
      //             "images_id": 1,
      //             "business_case_id": 3,
      //             "file_name": "231663_1244100169_large.jpg",
      //             "file_path": "C:\\Inetpub\\gri_backend\\app\\../uploads\\business_cases\\3",
      //             "time_stamp": "2020-08-13 17:48:12"
      //         },
      //         {
      //             "index": 1,
      //             "images_id": 2,
      //             "business_case_id": 3,
      //             "file_name": "1402725_55047002.jpg",
      //             "file_path": "C:\\Inetpub\\gri_backend\\app\\../uploads\\business_cases\\3",
      //             "time_stamp": "2020-08-13 17:50:10"
      //         }
      //     ]
      // }
    ],
    business_case_loaded: false,
    selected_business_case_id: null
  },
  mutations: {
    update_unlink_story_board(state, payload) {
      const index = state.business_case_list.findIndex(
        business_case_info => business_case_info.business_case_id === payload.id
      );
      if (index > -1) {
        const sb_index = state.business_case_list[index].used_codes_story_board.findIndex(
          item => item.id === payload.disclosure_id
        );
        state.business_case_list[index].used_codes_story_board.splice(sb_index, 1);
      }
    },
    update_linked_story_board(state, payload) {
      const index = state.business_case_list.findIndex(
        business_case_info => business_case_info.business_case_id === payload.business_case_id
      );
      if (index !== -1) {
        const sb_index = state.business_case_list[index]['used_codes_story_board'].findIndex(
          linked_info => linked_info.id === payload.linked_data.id
        );
        if (sb_index > -1) {
          state.business_case_list[index]['used_codes_story_board'][sb_index] = {
            ...state.business_case_list[index],
            ...payload.linked_data
          };
        } else {
          state.business_case_list[index]['used_codes_story_board'].push(payload.linked_data);
        }
      }

      // 기존 연결 제거
      if (payload?.before_item_id) {
        const before_item_index = state.business_case_list.findIndex(
          business_case_info => business_case_info.business_case_id === payload.before_item_id
        );
        const before_sb_index = state.business_case_list[before_item_index][
          'used_codes_story_board'
        ].findIndex(item => item.id === payload.linked_data.id);
        state.business_case_list[before_item_index]['used_codes_story_board'].splice(
          before_sb_index,
          1
        );
      }
    },
    update_selected_business_case_id(state, selected_id) {
      state.selected_business_case_id = selected_id;
    },
    update_business_case_list(state, new_business_case_list) {
      state.business_case_list = new_business_case_list;
    },
    add_or_update_business_case(state, new_business_case_obj) {
      const temp_business_case_list = [...state.business_case_list];
      const idx = temp_business_case_list.findIndex(
        item => item.business_case_id == new_business_case_obj.business_case_id
      );
      if (idx > -1) {
        const temp_business_case_obj = { ...new_business_case_obj };
        temp_business_case_obj.used_codes = temp_business_case_list[idx].used_codes;
        temp_business_case_obj.used_codes_sasb = temp_business_case_list[idx].used_codes_sasb;
        temp_business_case_obj.used_codes_tcfd = temp_business_case_list[idx].used_codes_tcfd;
        temp_business_case_obj.used_codes_story_board =
          temp_business_case_list[idx].used_codes_story_board;
        temp_business_case_list.splice(idx, 1, temp_business_case_obj);
      } else {
        new_business_case_obj.used_codes = [];
        new_business_case_obj.used_codes_sasb = [];
        new_business_case_obj.used_codes_tcfd = [];
        new_business_case_obj.used_codes_story_board = [];
        new_business_case_obj.badge_text =
          new_business_case_obj.badge_text !== undefined &&
          new_business_case_obj.badge_text !== null
            ? new_business_case_obj.badge_text
            : '';
        temp_business_case_list.push(new_business_case_obj);
      }
      state.business_case_list = temp_business_case_list;
    },
    update_business_case_e(state, new_translated_obj) {
      const temp_bc_list = [...state.business_case_list];
      const idx = temp_bc_list.findIndex(
        item => item.business_case_id == new_translated_obj.business_case_id
      );
      if (idx > -1) {
        (temp_bc_list[idx].title_em = new_translated_obj.title_em),
          (temp_bc_list[idx].title_ea = new_translated_obj.title_ea),
          (temp_bc_list[idx].description_em = new_translated_obj.description_em),
          (temp_bc_list[idx].description_ea = new_translated_obj.description_ea),
          (temp_bc_list[idx].files_e = new_translated_obj.files_e),
          (temp_bc_list[idx].images_e = new_translated_obj.images_e),
          (temp_bc_list[idx].badge_text_em = new_translated_obj.badge_text_em),
          (temp_bc_list[idx].badge_text_ea = new_translated_obj.badge_text_ea);
      }
      state.business_case_list = temp_bc_list;
    },
    update_business_case_relation(state, gri_codes_by_business_case_id) {
      const temp_business_case_list = [...state.business_case_list];
      temp_business_case_list.forEach(business_case => {
        if (gri_codes_by_business_case_id.hasOwnProperty(business_case.business_case_id)) {
          business_case['used_codes'] =
            gri_codes_by_business_case_id[business_case.business_case_id];
        }
      });
      //State 인식
      state.business_case_list = temp_business_case_list;
    },
    delete_file_from_business_case(state, { del_file_id, del_business_case_id }) {
      const temp_business_case_list = [...state.business_case_list];
      const idx = temp_business_case_list.findIndex(
        item => item.business_case_id == del_business_case_id
      );
      if (idx > -1) {
        const jdx = temp_business_case_list[idx].files.findIndex(x => x.file_id == del_file_id);
        if (jdx > -1) {
          temp_business_case_list[idx].files.splice(jdx, 1);
        }
      }
      state.business_case_list = temp_business_case_list;
    },
    update_delete_business_case(state, deleted_business_case_id) {
      // 1. business_case_list 배열 보장
      const temp_business_case_list = Array.isArray(state.business_case_list)
        ? [...state.business_case_list]
        : [];

      // 2. undefined 혹은 null id 방어
      if (!deleted_business_case_id) {
        // 로그만 남기고 조용히 리턴
        console.warn('[비즈니스 사례 삭제] 삭제할 business_case_id가 undefined이거나 null입니다.');
        return;
      }

      // 3. 실제 해당 id 찾기
      const idx = temp_business_case_list.findIndex(
        x => x.business_case_id == deleted_business_case_id
      );

      if (idx > -1) {
        temp_business_case_list.splice(idx, 1);
      } else {
        // 못 찾은 경우도 로그 남기기(필수는 아님)
        console.warn(
          `[비즈니스 사례 삭제] business_case_id(${deleted_business_case_id})를 business_case_list에서 찾지 못했습니다.`
        );
      }
      state.business_case_list = temp_business_case_list;
    },
    update_business_case_loaded(state, flag) {
      state.business_case_loaded = flag;
    }
  },
  getters: {
    hashed_business_cases(state) {
      const temp_bc_list = [...state.business_case_list];
      const temp_bc_obj = {};
      for (let i = 0; i < temp_bc_list.length; i++) {
        const bc_id = temp_bc_list[i].business_case_id;
        const bc_item = { ...temp_bc_list[i] };
        if (temp_bc_list[i].title_em != '' && temp_bc_list[i].title_em != null) {
          bc_item['title_e'] = temp_bc_list[i].title_em;
        } else bc_item['title_e'] = temp_bc_list[i].title_ea;
        if (temp_bc_list[i].description_em != '' && temp_bc_list[i].description_em != null) {
          bc_item['description_e'] = temp_bc_list[i].description_em;
        } else bc_item['description_e'] = temp_bc_list[i].description_ea;
        temp_bc_obj[bc_id] = bc_item;

        if (temp_bc_list[i].badge_text_em != '' && temp_bc_list[i].badge_text_em != null) {
          bc_item['badge_text_e'] = temp_bc_list[i].badge_text_em;
        } else bc_item['badge_text_e'] = temp_bc_list[i].badge_text_ea;
        temp_bc_obj[bc_id] = bc_item;
      }
      return temp_bc_obj;
    },
    business_case_used_codes(state) {
      const temp_list = [];
      const bc_arr = [...state.business_case_list];
      for (let i = 0; i < bc_arr.length; i++) {
        bc_arr[i].used_codes.forEach(x => {
          temp_list.push(x);
        });
      }
      const temp_list_a = [...new Set(temp_list)];
      return temp_list_a;
    },
    business_case_list_e(state) {
      const temp_bc_list = [...state.business_case_list];
      for (let i = 0; i < temp_bc_list.length; i++) {
        const bc_item = { ...temp_bc_list[i] };
        if (temp_bc_list[i].title_em != '' && temp_bc_list[i].title_em != null) {
          bc_item['title_e'] = temp_bc_list[i].title_em;
        } else bc_item['title_e'] = temp_bc_list[i].title_ea;
        if (temp_bc_list[i].description_em != '' && temp_bc_list[i].description_em != null) {
          bc_item['description_e'] = temp_bc_list[i].description_em;
        } else bc_item['description_e'] = temp_bc_list[i].description_ea;
        temp_bc_list[i] = bc_item;
      }
      // console.log(temp_bc_list);
      return temp_bc_list;
    }
  },
  actions: {
    async readBusinessCaseList({ commit }, { report_code, only_used, sort }) {
      commit('update_business_case_loaded', false);
      const path = '/read_business_case_list';

      try {
        const response = await publicApi.get(path, {
          params: {
            report_code: report_code,
            only_used: only_used != undefined ? only_used : null,
            sort: sort != undefined ? sort : null
          }
        });
        if (response) {
          commit('update_business_case_list', response.data);
          commit('update_business_case_loaded', true);
        }
      } catch (error) {
        error.message = '[비즈니스 사례 불러오기]' + error.message;
        Sentry.captureException(error);
      }
    },
    async saveBusinessCase(
      { commit },
      {
        report_code,
        business_case_id,
        title,
        description,
        files,
        images,
        e_mail,
        badge_text,
        bare_mode, // #777 미전송 시 백엔드가 기존값 유지
        silent = false
      }
    ) {
      const path = '/save_business_case';

      const formData = new FormData();
      if (business_case_id != null && business_case_id != undefined && business_case_id != '') {
        formData.append('business_case_id', business_case_id); //신규일 경우, business_case_id를 백엔드로 보내지 않아야 신규 생성하고 id를 부여받음
      }
      formData.append('report_code', report_code);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('files_id', JSON.stringify(files.map(item => item.file_id))); //최종 연결된 files_id 배열을 보냄
      formData.append('images_id', JSON.stringify(images.map(item => item.image_id))); //최종 연결된 image_id 배열을 보냄
      formData.append('last_editor', e_mail);
      formData.append('badge_text', badge_text);
      if (bare_mode !== undefined) {
        formData.append('bare_mode', bare_mode ? 'true' : 'false');
      }

      try {
        const response = await publicApi.post(path, formData);

        if (response.status === 200 && response.data) {
          // console.log(response)
          const new_business_case_obj = {
            business_case_id: response.data.business_case_id,
            report_code: response.data.report_code,
            title: response.data.title,
            description: response.data.description,
            time_stamp: response.data.time_stamp,
            files: response.data.files,
            images: response.data.images,
            badge_text: response.data.badge_text,
            bare_mode: response.data.bare_mode
          };
          commit('add_or_update_business_case', new_business_case_obj);
          commit(
            'story_board/update_disclosure_ert_data',
            {
              content_id: new_business_case_obj.business_case_id,
              type: 'business_case',
              data: new_business_case_obj
            },
            { root: true }
          );
          if (!silent) {
            Vue.prototype.$EventBus.$emit(
              'make-toast',
              '저장 완료',
              '비즈니스 케이스가 성공적으로 저장되었습니다.'
            );
          }

          return new_business_case_obj;
        } else if (!silent) {
          // 저장 실패 시 토스트 메시지 표시
          Vue.prototype.$EventBus.$emit(
            'make-toast',
            '저장 실패',
            '저장 중 오류가 발생했습니다.',
            false,
            'warning'
          );
        }
      } catch (error) {
        if (!silent) {
          Vue.prototype.$EventBus.$emit(
            'make-toast',
            '저장 실패',
            '서버와의 통신 중 오류가 발생했습니다.',
            false,
            'danger'
          );
        }
        error.message = '[비즈니스 사례 저장]' + error.message;
        Sentry.captureException(error);
      }
    },
    async updateBusinessCaseRelation(
      { commit },
      { report_code, gri_code, link_payload, framework }
    ) {
      const formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('gri_code', gri_code);
      formData.append('framework', framework);
      formData.append('link_payload', JSON.stringify(link_payload)); //{ "business_case_id": true } 형식의 object

      try {
        const response = await authApi.post('/link_disclosure_business_cases', formData);

        const business_case_ids_by_gri_code = response.data.business_case_ids_by_gri_code;
        //{ gri_code: [ business_case_ids ] }
        const gri_codes_by_business_case_id = response.data.gri_codes_by_business_case_id;
        //{ 'business_case_id': [ gri_codes ]}
        commit('update_business_case_relation', gri_codes_by_business_case_id);
        commit('report_contents/update_business_case_relation', business_case_ids_by_gri_code, {
          root: true
        });

        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '연결 완료',
          '비즈니스 케이스가 성공적으로 연결되었습니다.'
        );

        return response.data;
      } catch (error) {
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '연결 실패',
          '비즈니스 케이스 연결 중 오류가 발생했습니다.',
          false,
          'danger'
        );
        error.message = '[비즈니스 케이스 연결]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },
    async deleteFile({ commit }, { file_id, business_case_id }) {
      try {
        const response = await authApi.delete('/file/' + file_id);
        commit('delete_file_from_business_case', {
          del_file_id: response.data.file_id,
          del_business_case_id: business_case_id
        });
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '삭제 완료',
          '첨부파일이 성공적으로 삭제되었습니다.'
        );
        return response.data;
      } catch (error) {
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '삭제 실패',
          '첨부파일 삭제 중 오류가 발생했습니다.',
          false,
          'danger'
        );
        error.message = '[파일 삭제]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },
    async deleteBusinessCase({ commit }, business_case_id) {
      try {
        const response = await authApi.delete('/business_case/' + business_case_id);

        if (response.data.code) {
          const deleted_business_case_id = response.data.business_case_id;
          commit('update_delete_business_case', deleted_business_case_id);
          commit('report_contents/update_delete_business_case', deleted_business_case_id, {
            root: true
          });

          Vue.prototype.$EventBus.$emit(
            'make-toast',
            '삭제 성공',
            '비즈니스 케이스를 성공적으로 삭제했습니다.'
          );
        } else {
          Vue.prototype.$EventBus.$emit(
            'make-toast',
            '삭제 실패',
            response.data.msg || '비즈니스 케이스를 삭제하는 중 오류가 발생했습니다.',
            false,
            'warning'
          );
        }
      } catch (error) {
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '삭제 실패',
          '서버와의 통신 중 오류가 발생했습니다.',
          false,
          'danger'
        );
        error.message = '[비즈니스 사례 삭제]' + error.message;
        Sentry.captureException(error);
      }
    },
    async saveBusinessCaseEm(
      { commit },
      { business_case_id, title, description, files, images, badge_text }
    ) {
      const path = '/save_business_case_em';

      const formData = new FormData();
      formData.append('business_case_id', business_case_id);
      if (title != null && title != undefined) formData.append('title_em', title);
      if (description != null && description != undefined)
        formData.append('description_em', description);
      if (files != null && files != undefined && files != [])
        formData.append('files_id', JSON.stringify(files.map(item => item.file_id))); //최종 연결된 files_id 배열을 보냄
      if (images != null && images != undefined && images != [])
        formData.append('images_id', JSON.stringify(images.map(item => item.image_id))); //최종 연결된 image_id 배열을 보냄

      if (badge_text != null && badge_text != undefined && badge_text != '')
        formData.append('badge_text_em', badge_text);

      try {
        const response = await publicApi.post(path, formData);
        // console.log(response.data)
        commit('update_business_case_e', response.data);
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '저장 완료',
          '번역 비즈니스 케이스가 성공적으로 저장되었습니다.'
        );
        return response.data;
      } catch (error) {
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '저장 실패',
          '서버와의 통신 중 오류가 발생했습니다.',
          false,
          'danger'
        );
        error.message = '[비즈니스 케이스 번역 저장]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },
    async reInitiateBusinessCase({ commit }, { business_case_id, re_initiate }) {
      const path = '/translate_business_case';

      const formData = new FormData();
      formData.append('business_case_id', business_case_id);
      if (re_initiate != null && re_initiate != undefined)
        formData.append('re_initiate', re_initiate); //re_initiate 를 true로 보내면, direct_report_em을 삭제함

      try {
        const response = await publicApi.post(path, formData);
        // console.log(response.data);
        commit('update_business_case_e', response.data);
        return response.data;
      } catch (error) {
        error.message = '[비즈니스 케이스 번역 초기화]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },
    // #801 깊은 복사: files/images는 file_id/image_id 참조만 그대로 재사용 (백엔드도 id 배열만 받음).
    async duplicateBusinessCase({ dispatch, state, rootState }, { business_case_id, new_title }) {
      const source = state.business_case_list.find(
        item => item.business_case_id == business_case_id
      );
      if (!source) {
        Vue.prototype.$EventBus.$emit(
          'make-toast',
          '복제 실패',
          '원본 비즈니스 사례를 찾을 수 없습니다.',
          false,
          'warning'
        );
        return null;
      }
      try {
        return await dispatch('saveBusinessCase', {
          report_code: source.report_code,
          business_case_id: null,
          title: new_title,
          description: source.description || '',
          files: (source.files || []).map(f => ({ file_id: f.file_id })),
          images: (source.images || []).map(i => ({ image_id: i.image_id })),
          e_mail: rootState.e_mail,
          badge_text: source.badge_text || '',
          bare_mode: source.bare_mode
        });
      } catch (error) {
        error.message = '[비즈니스 사례 복제]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    }
  }
};

export default business_cases;
